const TYPES = {
  IFluoroAnglesCalculatorFactory: Symbol.for('IFluoroAnglesCalculatorFactory')
};

export { TYPES };
